import { Card, Col, Form, Button, Row } from "react-bootstrap";
import Table from "../../Components/UI/Table/Table";
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "../../utils/types";
import { useEffect, useState } from "react";
import { GetNoasCounterAction } from "../../Redux/Actions/AdminActions";
import "./admin.css";
import { useFormik } from "formik";
import { convertUtcToLocal, convertUtcToLocalWithSeconds } from "../../utils/functions";
import { ToastAction } from "../../Redux/Actions/ToastAction";
import CsvDownloader from "react-csv-downloader";

const NoasCounter = () => {
  const dispatch = useDispatch();
  const adminState = useSelector((state: IReduxState) => state.Admin);

  const typeOptions = [
    { value: "daily", label: "Daily" },
    { value: "hourly", label: "Hourly" },
  ];

  const [isHourly, setIsHourly] = useState(false);
  const [selectedType, setSelectedType] = useState("daily");

  const [csvData, setCsvData] = useState([]);

  const generateCsvData = (dataList:any) => {
    return dataList.map((data:any) => ({
      Date: convertUtcToLocal(data._id.countDate, "DD/MM/YYYY"),
      Time: isHourly ? convertUtcToLocalWithSeconds(data._id.countDate, "HH:mm") : "",
      Count: data.amountSum.toString(),
    }));
  };

  useEffect(() => {
    if (adminState.noas) {
      setCsvData(generateCsvData(adminState.noas));
    }
  }, [adminState.noas, isHourly]);

  const myFormik = useFormik({
    initialValues: {
      startDate: "",
      endDate: "",
      dailyHourly: "daily",
    },
    onSubmit: (value, { resetForm }) => {
      setIsHourly(selectedType === "hourly");
      let daterangevalid = true;
      if (value.startDate && value.endDate) {
        let start_dt = new Date(value.startDate);
        let end_dt = new Date(value.endDate);
        if (end_dt < start_dt) {
          daterangevalid = false;
          dispatch(ToastAction({ message: `End date can't be before start date`, severity: 'Danger', show: true }));
        }
      }
      if (daterangevalid) {
        dispatch(GetNoasCounterAction(value.startDate, value.endDate, selectedType));
      }
    },
  });

  useEffect(() => {
    dispatch(GetNoasCounterAction(null, null, selectedType));
  }, [dispatch]);

  const sizePerPageList = [
    {
      text: "10",
      value: 10,
    },
    {
      text: "25",
      value: 25,
    },
    {
      text: "50",
      value: 50,
    },
  ];

  let columns = [
    {
      Header: "Date",
      accessor: "",
      sort: false,
      Cell: ({ row }: any) => `${convertUtcToLocal(row.original._id.countDate, 'DD/MM/YYYY')}`,
    },
    ...(isHourly
      ? [
          {
            Header: "Time",
            accessor: "time",
            Cell: ({ row }: any) => convertUtcToLocalWithSeconds(row.original._id.countDate, "HH:mm"),
          },
        ]
      : []),
    {
      Header: "Count",
      accessor: "amountSum",
      sort: false,
    },
  ];

  let csvColumns = columns.map((column: any) => ({
    id: column.Header,
    displayName: column.Header,
  }));

  return (
    <>
      <Row className="d-flex justify-content-center mt-3">
        <Row>
          <p className="module_title" style={{ marginBottom: '0px' }}>
            NOAS Counter
          </p>
        </Row>
      </Row>
      <Card>
        <Card.Header
          style={{
            backgroundColor: "#fff",
            borderBottom: "0",
            marginTop: "20px",
            marginBottom: "20px",
          }}
        >
          <div className="tableActions">
            <Col>
              <Form.Label
                htmlFor="simpleinput"
                id="smallerFontSize"
                className="noMargin"
              >
                Date Range:
              </Form.Label>
              <div className="tableActions spaced">
                <div>
                  <Form.Control
                    id="example-date"
                    type="date"
                    name="startDate"
                    className="fsz-875rem"
                    value={myFormik.values.startDate}
                    onChange={myFormik.handleChange}
                    onBlur={myFormik.handleBlur}
                  />
                </div>
                <div>
                  <Form.Control
                    id="example-date"
                    type="date"
                    name="endDate"
                    className="fsz-875rem"
                    value={myFormik.values.endDate}
                    onChange={myFormik.handleChange}
                    onBlur={myFormik.handleBlur}
                  />
                </div>
                <div>
                  <Button
                    className="noMargin"
                    onClick={() => {
                      myFormik.handleSubmit();
                    }}
                    variant="success"
                  >
                    Apply
                  </Button>
                </div>
              </div>
            </Col>
            <Col style={{ display: "flex", justifyContent: "end" }}>
              <div className="order-12">
                <CsvDownloader
                  datas={csvData}
                  columns={csvColumns}
                  text="Export to CSV"
                  filename={`noas_` + new Date().toLocaleString()}
                  extension=".csv"
                  className="btn btn-primary ExportBtn no-margin"
                />
              </div>
            </Col>
          </div>
          <Row style={{ marginTop: '10px' }}>
            <div className="tableActions">
              <Col>
                <Form.Label
                  id="smallerFontSize"
                  className="noMargin"
                >
                  Event Type:
                </Form.Label>
                <Form.Select name="type" id="eType" className="fsz-875rem" style={{ borderRadius: "0.375rem", width: '473px', marginLeft: '37px' }}
                  onChange={(e) => {
                    setSelectedType(e.target.value);
                  }}
                  value={selectedType}>
                  {typeOptions.map((item: any) => (
                    <option key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </Form.Select>
              </Col>
            </div>
          </Row>
        </Card.Header>
        <Card.Body>
          <Table
            columns={columns}
            data={adminState.noas}
            pageSize={10}
            sizePerPageList={sizePerPageList}
            isSortable={false}
            pagination={true}
            isSearchable={false}
          />
        </Card.Body>
      </Card>
    </>
  );
};

export default NoasCounter;
